import { useState, useEffect, useMemo } from 'react';
import useERC1155Balances from 'src/hooks/useERC1155Balances';
import useUserCollections from 'src/hooks/useUserCollections'; // this makes the API call
import { CONTRACT_NAMES } from 'src/base/constants';
import useNetwork from 'src/hooks/useNetwork';
import { trpcClient } from '../../../trpc/client';

export type ZombiePurgeTokenConfig = {
	limit: number;
	minted: number;
	startDate: number;
	endDate: number;
	hasPassed: boolean;
}


const useZombiePurge = (address, zombieContract, lootContract) => {
	const [purgeStarted, setPurgeStarted] = useState(false);
	const [purgeStart, setPurgeStart] = useState(0);
	const [loading, setLoading] = useState(true);
	const { network } = useNetwork();


	const lootTokenIdsMemoized = useMemo(() => [0], []);

	const collectionsBalances = useUserCollections(address, [CONTRACT_NAMES.ZAYC]);
	const zombies = collectionsBalances[CONTRACT_NAMES.ZAYC];

	const { balances: lootBalances } = useERC1155Balances(address, lootContract, lootTokenIdsMemoized);

	useEffect(() => {
		if (!address) {
			setLoading(false);
		} else {
			setLoading(collectionsBalances.loading);
		}
	}, [address, collectionsBalances.loading]);

	useEffect(() => {
		async function main() {
			try {
				// TODO: get this info from API instead
				if (!lootContract || network === null) return false;

				const tokenConfig = await trpcClient.getLootPieceTokenConfig.query({ pieceId: String(0), network })

				const { startDate, hasPassed } = tokenConfig

				setPurgeStarted(hasPassed);
				setPurgeStart(startDate);
			} catch (e) {
				console.error('Error in useZombiePurge', e);
			}
		}
		main();

	}, [lootContract]);

	return ({
		lootBalances,
		zombies,
		loading,
		purgeStarted,
		purgeStart,
	});
};

export default useZombiePurge;